import React from "react";
import {
  Contact,
  ContactField,
} from "../../../../features/card-to-crm/types/cardToCrm.types";

/** The fields business_card/app.py actually returns, in display order.
 *  `linkedin_url`/`address` were dropped backend-side in d385261. */
export const CONTACT_FIELDS: {
  field: ContactField;
  label: string;
  type?: string;
}[] = [
  { field: "name", label: "Name" },
  { field: "title", label: "Title" },
  { field: "company", label: "Company" },
  { field: "email", label: "Email", type: "email" },
  { field: "phone", label: "Phone", type: "tel" },
  { field: "mobile", label: "Mobile", type: "tel" },
  { field: "website", label: "Website", type: "url" },
];

/** Best available label for a scanned card — name, else company, else email. */
export const contactLabel = (contact: Contact): string =>
  (contact.name || contact.company || contact.email || "Unnamed card").trim();

/** One contact per line, comma-separated — the shape looksLikeContactDump()
 *  and the /contacts/import parser both already understand. */
export const contactsToText = (contacts: Contact[]): string =>
  contacts
    .map((c) =>
      CONTACT_FIELDS.map(({ field }) => c[field])
        .filter((v): v is string => Boolean(v && v.trim()))
        .join(", ")
    )
    .filter(Boolean)
    .join("\n");

interface ContactFieldsEditorProps {
  contact: Contact;
  onChange: (field: ContactField, value: string) => void;
  disabled?: boolean;
}

/** The editable field grid for one scanned contact. Shared by the capture
 *  panel's review step and the composer chip's edit dialog so the two can't
 *  drift apart. */
export const ContactFieldsEditor: React.FC<ContactFieldsEditorProps> = ({
  contact,
  onChange,
  disabled = false,
}) => (
  <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
    {CONTACT_FIELDS.map(({ field, label, type }) => (
      <label key={field}>
        <span className="mb-1 block text-[11px] font-medium text-theme-fg-muted">
          {label}
        </span>
        <input
          type={type ?? "text"}
          value={contact[field] ?? ""}
          placeholder="—"
          disabled={disabled}
          onChange={(e) => onChange(field, e.target.value)}
          className="w-full rounded-lg border border-theme-border bg-theme-surface px-2.5 py-2 text-[13px] text-theme-fg outline-none focus:border-theme-primary disabled:opacity-60"
        />
      </label>
    ))}
  </div>
);
